function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        function () {
          callback(window.WebViewJavascriptBridge);
        },
        false
      );
    }
  
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
  export default {
    callhandler(data, callback) {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler("wsm_app_echo", data, callback)
      })
    },
    registerhandler(name, callback) {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.registerHandler("wsm_js_echo", function (data, responseCallback) {
          if (data === "userinfo") {
            responseCallback({
              title: "",
              userguid: ""
            })
          }
        })
      })
    }
  }
  


// WEBPACK FOOTER //
// ./src/assets/js/bridge.js